import { ProgressBar } from "react-bootstrap";

import { DEFAULT_VALUE } from "../../../constants";
import { buildTestId, compactNumberFormat } from "../../../../../shared";

const ProgressCard = ({ label, data, colorClass }) => {
  if (!data) return null;

  const cardTestId = buildTestId("progress-card", label);
  const valueTestId = buildTestId("progress-card", label, "value");
  const percentageTestId = buildTestId("progress-card", label, "percentage");

  return (
    <div className="mb-3" data-testid={cardTestId}>
      <div className="d-flex justify-content-between align-items-center">
        <span className="text-secondary text-uppercase">{label}</span>
        <div className="d-flex gap-2 align-items-baseline">
          <span
            className="fw-bolder insight-value"
            data-testid={valueTestId}
          >
            {compactNumberFormat(data.value ?? DEFAULT_VALUE)}
          </span>
          <span
            className="text-secondary small"
            data-testid={percentageTestId}
          >
            {data.percentage ?? DEFAULT_VALUE}%
          </span>
        </div>
      </div>
      <ProgressBar
        now={data.percentage ?? DEFAULT_VALUE}
        className={`mt-2 custom-progress ${colorClass}`}
      />
    </div>
  );
};

export default ProgressCard;
